// src/services/categoryService.ts
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

interface Category {
  id: string;
  name: string;
  description: string;
  specifications: {
    gsm: string;
    size: string;
    sheets: string;
  };
  createdAt: Date;
  updatedAt: Date;
}

interface Brand {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

class CategoryService {
  private categoriesCollection = collection(db, 'categories');
  private brandsCollection = collection(db, 'brands');

  async getAllCategories(): Promise<Category[]> {
    const snapshot = await getDocs(this.categoriesCollection);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Category[];
  }

  async getAllBrands(): Promise<Brand[]> {
    const snapshot = await getDocs(this.brandsCollection);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Brand[];
  }

  async addCategory(category: Omit<Category, 'id'>): Promise<string> {
    const docRef = await addDoc(this.categoriesCollection, {
      ...category,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return docRef.id;
  }

  async addBrand(brand: Omit<Brand, 'id'>): Promise<string> {
    const docRef = await addDoc(this.brandsCollection, {
      ...brand,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    return docRef.id;
  }

  async deleteCategory(id: string): Promise<void> {
    await deleteDoc(doc(this.categoriesCollection, id));
  }

  async updateCategory(id: string, category: Partial<Category>): Promise<void> {
    const categoryRef = doc(this.categoriesCollection, id);
    await updateDoc(categoryRef, category);
  }

  async updateBrand(id: string, brand: Partial<Brand>): Promise<void> {
    const brandRef = doc(this.brandsCollection, id);
    await updateDoc(brandRef, brand);
  }

  async deleteBrand(id: string): Promise<void> {
    try {
      const brandRef = doc(this.brandsCollection, id);
      await deleteDoc(brandRef);
    } catch (error) {
      console.error('Error deleting brand:', error);
      throw error;
    }
  }

  
  

}

export const categoryService = new CategoryService();